import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import '../styles/ShopStyles.css';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';

// --- SVG ICONS ---
const SearchIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="grey-navbar-svg-icon"
  >
    <circle cx="9" cy="9" r="7" stroke="#222" strokeWidth="2" />
    <line x1="14.5" y1="14.5" x2="19" y2="19" stroke="#222" strokeWidth="2" strokeLinecap="round" />
  </svg>
);
const CartIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="grey-navbar-svg-icon"
  >
    <circle cx="8" cy="19" r="1.2" stroke="#222" strokeWidth="1.5" />
    <circle cx="17" cy="19" r="1.2" stroke="#222" strokeWidth="1.5" />
    <path
      d="M2 2H4.5L6.5 14.5H18L20 6.5H6.5"
      stroke="#222"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
const HamburgerIcon = () => (
  <svg
    width="28"
    height="22"
    viewBox="0 0 28 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="grey-navbar-svg-icon"
  >
    <rect y="2" width="28" height="2" rx="1" fill="#222" />
    <rect y="10" width="28" height="2" rx="1" fill="#222" />
    <rect y="18" width="28" height="2" rx="1" fill="#222" />
  </svg>
);
const CloseIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="grey-navbar-svg-icon"
  >
    <line x1="6" y1="6" x2="22" y2="22" stroke="#222" strokeWidth="2" strokeLinecap="round" />
    <line x1="22" y1="6" x2="6" y2="22" stroke="#222" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.085"
      fill="white"
    />
  </svg>
);

const Header = (props) => {
  // State for mobile menu, auth, dropdowns, etc.
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 1024 : false
  );
  const [shopDropdownOpen, setShopDropdownOpen] = useState(false);
  const shopDropdownTimeout = useRef();
  const { currentUser, login, signup, logout, loading } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState('login'); // 'login' or 'signup'
  const [authEmail, setAuthEmail] = useState('');
  const [authPassword, setAuthPassword] = useState('');
  const [authError, setAuthError] = useState('');
  const [userDropdown, setUserDropdown] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [scrolled, setScrolled] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const { totalItems } = useCart();
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const handleNavClose = () => {
    if (isNavOpen) {
      setIsClosing(true);
      setTimeout(() => {
        setIsNavOpen(false);
        setIsClosing(false);
      }, 300); // Match the transition duration
    }
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      setTimeout(() => setMenuVisible(true), 10);
    } else {
      setMenuVisible(false);
    }
  }, [isMobileMenuOpen]);

  // Body scroll lock for mobile menu
  useEffect(() => {
    if (isMobile && isNavOpen) {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.top = `-${window.scrollY}px`;
    } else {
      const scrollY = document.body.style.top;
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
      if (scrollY) {
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
      }
    }
    
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
    };
  }, [isNavOpen, isMobile]);

  const handleAuth = async (e) => {
    e.preventDefault();
    setAuthError('');
    try {
      if (authMode === 'login') {
        await login(authEmail, authPassword);
      } else {
        const user = await signup(authEmail, authPassword);
        if (user && user.updateProfile) {
          await user.updateProfile({ displayName: `${firstName} ${lastName}` });
        }
      }
      setShowAuthModal(false);
      setAuthEmail('');
      setAuthPassword('');
      setFirstName('');
      setLastName('');
      setConfirmEmail('');
      setConfirmPassword('');
    } catch (err) {
      setAuthError(err.message);
    }
  };

  const handleLogout = async () => {
    await logout();
    setUserDropdown(false);
  };

  // Helper to get first name
  const getFirstName = (user) => {
    if (!user) return 'User';
    if (user.displayName) return user.displayName.split(' ')[0];
    return 'User';
  };

  const navLinkStyle = {
    display: 'block',
    padding: '15px 0',
    textDecoration: 'none',
    color: '#333',
    fontSize: '18px',
    borderBottom: '1px solid #eee',
  };

  return (
    <>
      {/* Mobile Sidebar Overlay */}
      {isMobile && (
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.6)',
            zIndex: isNavOpen || isClosing ? 1999 : -1,
            opacity: isNavOpen && !isClosing ? 1 : 0,
            transition: 'opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            pointerEvents: isNavOpen && !isClosing ? 'auto' : 'none',
          }}
          onClick={handleNavClose} 
        />
      )}
      
      {/* Mobile Sidebar - Editorial Design */}
      {isMobile && (
        <aside 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: isNavOpen || isClosing ? 2000 : -1,
            transform: isNavOpen && !isClosing ? 'translateX(0)' : 'translateX(-100%)',
            background: '#fff',
            transition: 'transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
          }}
        >
          {/* Header Section */}
          <div style={{
            padding: '60px 32px 40px',
            borderBottom: '1px solid #e8e8e8',
            position: 'relative'
          }}>
            <button
              style={{
                position: 'absolute',
                top: 24,
                right: 24,
                background: 'none',
                border: 'none',
                fontSize: 28,
                cursor: 'pointer',
                color: '#333',
                padding: 12,
                borderRadius: '0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s ease',
                fontWeight: '300'
              }}
              onClick={handleNavClose}
              aria-label="Close menu"
            >
              ×
            </button>
            
            <div style={{textAlign: 'center'}}>
              <img src="/images/logo.png" alt="GREY" style={{height: 48, margin: '0 auto', display: 'block'}} />
            </div>
          </div>
          
          {/* Navigation Section */}
          <nav style={{
            flex: 1,
            padding: '48px 0',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px'
          }}>
            <a 
              href="/" 
              onClick={() => setIsNavOpen(false)} 
              style={{
                display: 'block',
                padding: '20px 48px',
                textDecoration: 'none',
                color: '#181818',
                fontSize: '18px',
                fontWeight: '500',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                borderBottom: '1px solid transparent',
                width: '200px'
              }}
              onMouseEnter={(e) => {
                e.target.style.borderBottomColor = '#181818';
                e.target.style.color = '#000';
              }}
              onMouseLeave={(e) => {
                e.target.style.borderBottomColor = 'transparent';
                e.target.style.color = '#181818';
              }}
            >
              Home
            </a>
            
            <a 
              href="/catalogue" 
              onClick={() => setIsNavOpen(false)} 
              style={{
                display: 'block',
                padding: '20px 48px',
                textDecoration: 'none',
                color: '#181818',
                fontSize: '18px',
                fontWeight: '500',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                borderBottom: '1px solid transparent',
                width: '200px'
              }}
              onMouseEnter={(e) => {
                e.target.style.borderBottomColor = '#181818';
                e.target.style.color = '#000';
              }}
              onMouseLeave={(e) => {
                e.target.style.borderBottomColor = 'transparent';
                e.target.style.color = '#181818';
              }}
            >
              Catalogue
            </a>
            
            <a 
              href="/menu" 
              onClick={() => setIsNavOpen(false)} 
              style={{
                display: 'block',
                padding: '20px 48px',
                textDecoration: 'none',
                color: '#181818',
                fontSize: '18px',
                fontWeight: '500',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                borderBottom: '1px solid transparent',
                width: '200px'
              }}
              onMouseEnter={(e) => {
                e.target.style.borderBottomColor = '#181818';
                e.target.style.color = '#000';
              }}
              onMouseLeave={(e) => {
                e.target.style.borderBottomColor = 'transparent';
                e.target.style.color = '#181818';
              }}
            >
              Menu
            </a>
            
            <a 
              href="/about" 
              onClick={() => setIsNavOpen(false)} 
              style={{
                display: 'block',
                padding: '20px 48px',
                textDecoration: 'none',
                color: '#181818',
                fontSize: '18px',
                fontWeight: '500',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                borderBottom: '1px solid transparent',
                width: '200px'
              }}
              onMouseEnter={(e) => {
                e.target.style.borderBottomColor = '#181818';
                e.target.style.color = '#000';
              }}
              onMouseLeave={(e) => {
                e.target.style.borderBottomColor = 'transparent';
                e.target.style.color = '#181818';
              }}
            >
              About
            </a>
            
            <Link 
              to="/cart" 
              onClick={() => setIsNavOpen(false)} 
              style={{
                display: 'block',
                padding: '20px 48px',
                textDecoration: 'none',
                color: '#181818',
                fontSize: '18px',
                fontWeight: '500',
                textTransform: 'uppercase',
                letterSpacing: '2px',
                textAlign: 'center',
                transition: 'all 0.3s ease',
                borderBottom: '1px solid transparent',
                width: '200px'
              }}
              onMouseEnter={(e) => {
                e.target.style.borderBottomColor = '#181818';
                e.target.style.color = '#000';
              }}
              onMouseLeave={(e) => {
                e.target.style.borderBottomColor = 'transparent';
                e.target.style.color = '#181818';
              }}
            >
              Cart
              {totalItems > 0 && (
                <span style={{
                  marginLeft: '8px',
                  background: '#333',
                  color: '#fff',
                  borderRadius: '0',
                  padding: '2px 8px',
                  fontSize: '12px',
                  fontWeight: '600'
                }}>
                  {totalItems}
                </span>
              )}
            </Link>
          </nav>
          
          {/* Footer Section */}
          <div style={{
            padding: '32px',
            borderTop: '1px solid #e8e8e8',
            textAlign: 'center'
          }}>
            <p style={{
              fontSize: '12px',
              color: '#888',
              margin: '0',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              © 2024 GREY Coffee
            </p>
          </div>
        </aside>
      )}

      {isMobile ? (
        <header className={`mobile-header-container ${scrolled ? 'scrolled' : 'top'}`}>
          <div className="mobile-header-inner">
            <div className="mobile-header-left">
            <button
                className="mobile-header-btn"
                onClick={() => setIsNavOpen(true)}
                aria-label="Open menu"
            >
                <HamburgerIcon />
            </button>
            </div>
            <div className="mobile-header-center">
              <Link to="/" className="mobile-header-logo-link">
              <img
                  src="/images/logo.png"
                alt="GREY"
                  className="mobile-header-logo"
              />
            </Link>
              </div>
            <div className="mobile-header-right">
              <Link 
                to="/cart" 
                className="mobile-header-btn"
                aria-label="Cart"
              >
                <CartIcon />
                {totalItems > 0 && (
                  <span className="mobile-cart-badge">{totalItems}</span>
                )}
              </Link>

              {props.showLangToggle && (
                <button 
                  className="mobile-header-btn lang-toggle"
                  onClick={() => props.setLanguage(lang => lang === 'en' ? 'ar' : 'en')}
                >
                  {props.language === 'en' ? 'AR' : 'EN'}
                </button>
              )}
            </div>
          </div>
        </header>
      ) : (
        <>
          <div className="grey-header-top-padding" />
          <header className="grey-header-logo-section">
            <Link to="/">
              <img src="/images/logo.png" alt="GREY" className="grey-header-logo-png" />
            </Link>
          </header>
          <div className="grey-header-logo-spacer" />
          {/* Navbar: About, Shop, Search (left); Cart, Hamburger (right) */}
          <nav className="grey-navbar-above-divider">
            <div className="grey-navbar-above-divider-left grey-navbar-desktop">
              <Link to="/about" className="grey-navbar-link">
                About
              </Link>
              <div
                className="grey-navbar-shop-wrapper"
                style={{ position: 'relative', display: 'inline-block' }}
              >
                <Link to="/catalogue" className="grey-navbar-link">
                  Catalogue
                </Link>
              </div>
              <a href="/menu" className="grey-navbar-link grey-navbar-menu">
                Menu
              </a>
            </div>
            <div className="grey-navbar-above-divider-right">
              <Link 
                to="/cart"
                className="grey-navbar-link grey-navbar-cart grey-navbar-desktop" 
                style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                <CartIcon />
                <span>Cart</span>
                {totalItems > 0 && (
                  <span style={{
                    marginLeft: '8px',
                    background: '#222',
                    color: '#fff',
                    borderRadius: '50%',
                    minWidth: '20px',
                    height: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '12px',
                    fontWeight: '700'
                  }}>
                    {totalItems}
                  </span>
                )}
              </Link>
            </div>
          </nav>
          <hr className="grey-navbar-divider-struct" />
          <div className="grey-header-below-divider-spacer" />
        </>
      )}
      {/* --- MOBILE MENU OVERLAY --- */}
      {isMobileMenuOpen && (
        <>
          {/* Overlay */}
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.4)',
            zIndex: 1999,
            opacity: menuVisible ? 1 : 0,
            transition: 'opacity 0.32s',
            pointerEvents: menuVisible ? 'auto' : 'none',
          }} onClick={() => { setMenuVisible(false); setTimeout(() => setMobileMenuOpen(false), 350); }} />
          {/* Drawer */}
          <div style={{
            borderRadius: '0 22px 22px 0',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '86vw',
            maxWidth: 410,
            height: '100vh',
            background: '#EDEDED',
            zIndex: 2000,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: 0,
            boxSizing: 'border-box',
            overflowY: 'auto',
            transition: 'transform 0.38s cubic-bezier(.77,0,.18,1), opacity 0.28s',
            transform: menuVisible ? 'translateX(0)' : 'translateX(-100vw)',
            opacity: menuVisible ? 1 : 0.7,
            boxShadow: '4px 0 32px 0 rgba(0,0,0,0.10)',
          }}>
            <button
              aria-label="Close"
              onClick={() => { setMenuVisible(false); setTimeout(() => setMobileMenuOpen(false), 350); }}
              style={{
                position: 'absolute',
                top: 18,
                right: 18,
                background: 'none',
                border: 'none',
                fontSize: 28,
                color: '#2C2C2C',
                cursor: 'pointer',
                zIndex: 2010,
                padding: 0,
                margin: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'color 0.18s',
              }}
            >
              <CloseIcon />
            </button>
            {/* Profile Card or Welcome Card */}
            <div style={{
              width: '100%',
              maxWidth: 380,
              background: '#fff',
              borderRadius: '0 0 22px 22px',
              boxShadow: '0 4px 18px rgba(44,44,44,0.07)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '32px 0 18px 0',
              marginBottom: 18,
              borderBottom: '1.5px solid #ececec',
              transition: 'box-shadow 0.18s',
            }}>
              {currentUser ? (
                <>
                  <div style={{ width: 82, height: 82, borderRadius: '50%', background: '#EDEDED', overflow: 'hidden', marginBottom: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36, fontWeight: 800, color: '#2C2C2C' }}>
                    {currentUser.photoURL ? (
                      <img src={currentUser.photoURL} alt="avatar" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    ) : (
                      getFirstName(currentUser)[0].toUpperCase()
                    )}
                  </div>
                  <div style={{ fontWeight: 800, fontSize: 22, color: '#2C2C2C', marginBottom: 2, letterSpacing: 0.2 }}>{getFirstName(currentUser)}</div>
                  <div style={{ fontSize: 15, color: '#888', marginBottom: 0 }}>{currentUser.email}</div>
                </>
              ) : (
                <>
                  <div style={{ width: 82, height: 82, borderRadius: '50%', background: '#EDEDED', overflow: 'hidden', marginBottom: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 36, fontWeight: 800, color: '#2C2C2C' }}>
                    <span>👤</span>
                  </div>
                  <div style={{ fontWeight: 800, fontSize: 22, color: '#2C2C2C', marginBottom: 2, letterSpacing: 0.2 }}>Welcome</div>
                  <div style={{ fontSize: 15, color: '#888', marginBottom: 0 }}>Sign in to your account</div>
                </>
              )}
            </div>
            {/* Menu List */}
            <nav style={{ width: '100%', maxWidth: 380, display: 'flex', flexDirection: 'column', gap: 0 }}>
              {/* Home */}
              <Link to="/" onClick={() => setMobileMenuOpen(false)} style={{ ...menuItemStyle, color: '#2C2C2C', fontWeight: hoveredMenu === 'home' ? 800 : 700, background: hoveredMenu === 'home' ? '#e0e0e0' : 'none' }} onMouseEnter={() => setHoveredMenu('home')} onMouseLeave={() => setHoveredMenu(null)}><span style={{ ...iconStyle, color: hoveredMenu === 'home' ? '#2C2C2C' : '#A6A6A6' }}>{homeIcon}</span>Home</Link>
              {/* About */}
              <Link to="/about" onClick={() => setMobileMenuOpen(false)} style={{ ...menuItemStyle, color: '#2C2C2C', fontWeight: hoveredMenu === 'about' ? 800 : 700, background: hoveredMenu === 'about' ? '#e0e0e0' : 'none' }} onMouseEnter={() => setHoveredMenu('about')} onMouseLeave={() => setHoveredMenu(null)}><span style={{ ...iconStyle, color: hoveredMenu === 'about' ? '#2C2C2C' : '#A6A6A6' }}>{aboutIcon}</span>About</Link>
              {/* Shop (expandable) */}
              <div style={{ width: '100%' }}>
                <button onClick={() => setShopDropdownOpen((v) => !v)} style={{ ...menuItemStyle, width: '100%', background: hoveredMenu === 'shop' ? '#e0e0e0' : 'none', color: '#2C2C2C', fontWeight: hoveredMenu === 'shop' ? 800 : 700, border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', cursor: 'pointer' }} onMouseEnter={() => setHoveredMenu('shop')} onMouseLeave={() => setHoveredMenu(null)}>
                  <span style={{ ...iconStyle, color: hoveredMenu === 'shop' ? '#2C2C2C' : '#A6A6A6' }}>{shopIcon}</span>Shop <span style={{ marginLeft: 'auto', fontSize: 18, color: '#2C2C2C' }}>{shopDropdownOpen ? '▲' : '▼'}</span>
                </button>
                {shopDropdownOpen && (
                  <div style={{ width: '92%', margin: '0 auto 0 32px', background: '#EDEDED', borderRadius: 12, marginBottom: 6, padding: '6px 0', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', boxShadow: '0 2px 8px rgba(44,44,44,0.04)' }}>
                    <Link to="/catalogue" onClick={() => { setMobileMenuOpen(false); setShopDropdownOpen(false); }} style={{ ...menuItemStyle, fontSize: 16, padding: '8px 0 8px 32px', border: 'none', color: '#2C2C2C', background: hoveredMenu === 'shops' ? '#e0e0e0' : 'none', fontWeight: hoveredMenu === 'shops' ? 800 : 700 }} onMouseEnter={() => setHoveredMenu('shops')} onMouseLeave={() => setHoveredMenu(null)}><span style={{ ...iconStyle, color: hoveredMenu === 'shops' ? '#2C2C2C' : '#A6A6A6' }}>{catalogIcon}</span>Catalogue</Link>
                    <Link to="/products" onClick={() => { setMobileMenuOpen(false); setShopDropdownOpen(false); }} style={{ ...menuItemStyle, fontSize: 16, padding: '8px 0 8px 32px', border: 'none', color: '#2C2C2C', background: hoveredMenu === 'catalog' ? '#e0e0e0' : 'none', fontWeight: hoveredMenu === 'catalog' ? 800 : 700 }} onMouseEnter={() => setHoveredMenu('catalog')} onMouseLeave={() => setHoveredMenu(null)}><span style={{ ...iconStyle, color: hoveredMenu === 'catalog' ? '#2C2C2C' : '#A6A6A6' }}>{catalogIcon}</span>Catalog</Link>
                    <div style={{ ...menuItemStyle, fontSize: 16, padding: '8px 0 8px 32px', color: '#bbb', cursor: 'not-allowed', border: 'none', background: 'none' }}><span style={{ ...iconStyle, color: '#bbb' }}>{wholesaleIcon}</span>Wholesale <span style={{ marginLeft: 6, fontSize: 15, color: '#bbb' }}>🔒</span></div>
                  </div>
                )}
              </div>
              {/* Menu */}
              <Link to="/menu" onClick={() => setMobileMenuOpen(false)} style={{ ...menuItemStyle, color: '#2C2C2C', fontWeight: hoveredMenu === 'menu' ? 800 : 700, background: hoveredMenu === 'menu' ? '#e0e0e0' : 'none' }} onMouseEnter={() => setHoveredMenu('menu')} onMouseLeave={() => setHoveredMenu(null)}><span style={{ ...iconStyle, color: hoveredMenu === 'menu' ? '#2C2C2C' : '#A6A6A6' }}>{menuIcon}</span>Menu</Link>
              {/* Cart */}
              <Link to="/cart" onClick={() => setMobileMenuOpen(false)} style={{ ...menuItemStyle, color: '#2C2C2C', fontWeight: hoveredMenu === 'cart' ? 800 : 700, background: hoveredMenu === 'cart' ? '#e0e0e0' : 'none' }} onMouseEnter={() => setHoveredMenu('cart')} onMouseLeave={() => setHoveredMenu(null)}><span style={{ ...iconStyle, color: hoveredMenu === 'cart' ? '#2C2C2C' : '#A6A6A6' }}><CartIcon /></span>Cart</Link>
            </nav>
            {/* Auth Section */}
            <div style={{ width: '100%', maxWidth: 380, marginTop: 'auto', marginBottom: 18, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {currentUser ? (
                <button style={{ width: '92%', background: '#111111', color: '#FFFFFF', border: 'none', fontWeight: 700, fontSize: 17, borderRadius: 10, padding: '15px 0', margin: '0 auto', cursor: 'pointer', boxShadow: '0 2px 8px rgba(44,44,44,0.08)', transition: 'background 0.18s', marginTop: 10, letterSpacing: 0.2 }} onClick={handleLogout}><span style={{ ...iconStyle, color: '#fff' }}>{logoutIcon}</span>Log out</button>
              ) : (
                <button style={{ width: '92%', background: '#111111', color: '#FFFFFF', border: 'none', fontWeight: 700, fontSize: 17, borderRadius: 10, padding: '15px 0', margin: '0 auto', cursor: 'pointer', boxShadow: '0 2px 8px rgba(44,44,44,0.08)', transition: 'background 0.18s', marginTop: 10, letterSpacing: 0.2 }} onClick={() => { setShowAuthModal(true); setAuthMode('login'); setMobileMenuOpen(false); }}><span style={{ ...iconStyle, color: '#fff' }}>{loginIcon}</span>Login / Sign Up</button>
              )}
            </div>
          </div>
        </>
      )}
      {showAuthModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.18)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <form onSubmit={handleAuth} style={{
            background: 'rgba(255,255,255,0.13)',
            backdropFilter: 'blur(16px)',
            WebkitBackdropFilter: 'blur(16px)',
            border: '1.5px solid #222',
            boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
            minWidth: 340,
            maxWidth: 420,
            width: '90vw',
            fontFamily: 'Georgia, serif',
            fontWeight: 400,
            borderRadius: 0,
            padding: '38px 32px 28px 32px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            <h2 style={{ marginBottom: 24, fontWeight: 700, fontSize: 32, letterSpacing: '-0.01em', color: '#181818', textAlign: 'center', border: 'none', background: 'none', fontFamily: 'Georgia, serif' }}>{authMode === 'login' ? 'Login' : 'Sign Up'}</h2>
            {authMode === 'signup' && (
              <div style={{ display: 'flex', gap: 12, width: '100%', marginBottom: 16 }}>
                <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} placeholder="First Name" required style={{ width: '50%', padding: '12px 14px', fontSize: 18, fontFamily: 'Georgia, serif', fontWeight: 400, background: 'rgba(255,255,255,0.22)', border: '1.2px solid #222', borderRadius: 0, outline: 'none', color: '#181818', boxShadow: 'none', transition: 'border 0.18s', margin: 0 }} />
                <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} placeholder="Last Name" required style={{ width: '50%', padding: '12px 14px', fontSize: 18, fontFamily: 'Georgia, serif', fontWeight: 400, background: 'rgba(255,255,255,0.22)', border: '1.2px solid #222', borderRadius: 0, outline: 'none', color: '#181818', boxShadow: 'none', transition: 'border 0.18s', margin: 0 }} />
              </div>
            )}
            <input type="email" value={authEmail} onChange={e => setAuthEmail(e.target.value)} placeholder="Email" required style={{ width: '100%', marginBottom: 16, padding: '12px 14px', fontSize: 18, fontFamily: 'Georgia, serif', fontWeight: 400, background: 'rgba(255,255,255,0.22)', border: '1.2px solid #222', borderRadius: 0, outline: 'none', color: '#181818', boxShadow: 'none', transition: 'border 0.18s' }} />
            {authMode === 'signup' && (
              <input type="email" value={confirmEmail} onChange={e => setConfirmEmail(e.target.value)} placeholder="Confirm Email" required style={{ width: '100%', marginBottom: 16, padding: '12px 14px', fontSize: 18, fontFamily: 'Georgia, serif', fontWeight: 400, background: 'rgba(255,255,255,0.22)', border: '1.2px solid #222', borderRadius: 0, outline: 'none', color: '#181818', boxShadow: 'none', transition: 'border 0.18s' }} />
            )}
            <input type="password" value={authPassword} onChange={e => setAuthPassword(e.target.value)} placeholder="Password" required style={{ width: '100%', marginBottom: 16, padding: '12px 14px', fontSize: 18, fontFamily: 'Georgia, serif', fontWeight: 400, background: 'rgba(255,255,255,0.22)', border: '1.2px solid #222', borderRadius: 0, outline: 'none', color: '#181818', boxShadow: 'none', transition: 'border 0.18s' }} />
            {authMode === 'signup' && (
              <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Confirm Password" required style={{ width: '100%', marginBottom: 16, padding: '12px 14px', fontSize: 18, fontFamily: 'Georgia, serif', fontWeight: 400, background: 'rgba(255,255,255,0.22)', border: '1.2px solid #222', borderRadius: 0, outline: 'none', color: '#181818', boxShadow: 'none', transition: 'border 0.18s' }} />
            )}
            {authError && <div style={{ color: 'red', marginBottom: 8, fontFamily: 'Georgia, serif', fontWeight: 400 }}>{authError}</div>}
            <button type="submit" style={{ width: '100%', padding: '13px 0', fontWeight: 400, fontFamily: 'Georgia, serif', background: '#181818', color: '#fff', border: 'none', borderRadius: 0, fontSize: 20, marginBottom: 18, letterSpacing: '-0.01em', boxShadow: 'none', cursor: 'pointer', transition: 'background 0.18s' }}>{authMode === 'login' ? 'Login' : 'Sign Up'}</button>
            <div style={{ textAlign: 'center', fontSize: 18, fontFamily: 'Georgia, serif', fontWeight: 400, marginBottom: 18 }}>
              {authMode === 'login' ? (
                <>Don't have an account? <span style={{ color: '#0070f3', cursor: 'pointer', fontWeight: 700 }} onClick={() => setAuthMode('signup')}>Sign Up</span></>
              ) : (
                <>Already have an account? <span style={{ color: '#0070f3', cursor: 'pointer', fontWeight: 700 }} onClick={() => setAuthMode('login')}>Login</span></>
              )}
            </div>
            <button type="button" onClick={() => setShowAuthModal(false)} style={{ width: '100%', padding: '13px 0', background: 'rgba(255,255,255,0.7)', color: '#181818', border: '1.2px solid #222', borderRadius: 0, fontFamily: 'Georgia, serif', fontWeight: 400, fontSize: 20, boxShadow: 'none', cursor: 'pointer', transition: 'background 0.18s' }}>Cancel</button>
          </form>
        </div>
      )}

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/97450008852"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '24px',
          right: '24px',
          width: '60px',
          height: '60px',
          backgroundColor: '#25D366',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 20px rgba(37, 211, 102, 0.4)',
          zIndex: 1000,
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          textDecoration: 'none',
          cursor: 'pointer',
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'scale(1.1)';
          e.target.style.boxShadow = '0 6px 25px rgba(37, 211, 102, 0.6)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'scale(1)';
          e.target.style.boxShadow = '0 4px 20px rgba(37, 211, 102, 0.4)';
        }}
      >
        <WhatsAppIcon />
      </a>
    </>
  );
};

// --- ICONS & STYLES ---
const menuItemStyle = {
  padding: '16px 0',
  fontSize: 18,
  fontWeight: 700,
  color: '#222',
  textDecoration: 'none',
  textAlign: 'left',
  borderBottom: '1px solid #ececec',
  background: 'none',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: 18,
  border: 'none',
};
const iconStyle = { minWidth: 26, minHeight: 26, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#bbb' };
const homeIcon = (<svg width="22" height="22" fill="none" viewBox="0 0 22 22"><path d="M3 10.5L11 4l8 6.5" stroke="#bbb" strokeWidth="2" strokeLinejoin="round"/><rect x="6.5" y="12" width="9" height="6" rx="2" stroke="#bbb" strokeWidth="2"/></svg>);
const aboutIcon = (<svg width="22" height="22" fill="none" viewBox="0 0 22 22"><circle cx="11" cy="7" r="3" stroke="#bbb" strokeWidth="2"/><rect x="6" y="12" width="10" height="6" rx="3" stroke="#bbb" strokeWidth="2"/></svg>);
const shopIcon = (<svg width="22" height="22" fill="none" viewBox="0 0 22 22"><rect x="3" y="7" width="16" height="10" rx="3" stroke="#bbb" strokeWidth="2"/><rect x="7" y="3" width="8" height="4" rx="2" stroke="#bbb" strokeWidth="2"/></svg>);
const catalogIcon = (<svg width="22" height="22" fill="none" viewBox="0 0 22 22"><rect x="4" y="6" width="14" height="10" rx="2" stroke="#bbb" strokeWidth="2"/><path d="M8 10h6M8 14h6" stroke="#bbb" strokeWidth="2" strokeLinecap="round"/></svg>);
const wholesaleIcon = (<svg width="22" height="22" fill="none" viewBox="0 0 22 22"><rect x="4" y="6" width="14" height="10" rx="2" stroke="#bbb" strokeWidth="2"/><path d="M7 10h8M7 14h8" stroke="#bbb" strokeWidth="2" strokeLinecap="round"/></svg>);
const menuIcon = (<svg width="22" height="22" fill="none" viewBox="0 0 22 22"><rect x="4" y="7" width="14" height="8" rx="2" stroke="#bbb" strokeWidth="2"/><path d="M7 11h8" stroke="#bbb" strokeWidth="2" strokeLinecap="round"/></svg>);
const logoutIcon = (<svg width="22" height="22" fill="none" viewBox="0 0 22 22"><path d="M7 11h8M13 7l4 4-4 4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><rect x="3" y="3" width="10" height="16" rx="3" stroke="#fff" strokeWidth="2"/></svg>);
const loginIcon = (<svg width="22" height="22" fill="none" viewBox="0 0 22 22"><path d="M15 11H7M11 7l-4 4 4 4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><rect x="9" y="3" width="10" height="16" rx="3" stroke="#fff" strokeWidth="2"/></svg>);

export default Header;
